import { DataCell } from "../atoms/DataCell";
import { STYLES } from "../../config/styles";

interface ResidentNameCellProps {
  residentName: string | undefined;
  href?: string;
  fallback?: string;
}

// Helper function to convert to mixed case (Title Case)
function toMixedCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function ResidentNameCell({ residentName, href = "#", fallback = "—" }: ResidentNameCellProps) {
  const displayName = residentName ? toMixedCase(residentName) : fallback;
  const hasValue = !!residentName;

  return (
    <td className={STYLES.table.cellPadding}>
      <DataCell muted={!hasValue}>
        {hasValue ? (
          <a
            href={href}
            className="text-[#228189] underline hover:text-[#1a6b73] transition-colors"
          >
            {displayName}
          </a>
        ) : (
          displayName
        )}
      </DataCell>
    </td>
  );
}
